<template>
    <div class="mDataList">
        <div class="box" v-for="(obj) in orderList" :key="obj.innerid">
            <div class="top" @click="gotoView(obj)">
                <span>订单号：{{obj.orderno}}</span>
                <!--<span>{{obj.datetime}}</span>-->
                <span :class="cls(obj.status)">{{obj.statustext}}</span>
            </div>
            <div class="middle" @click="gotoView(obj)">
                <div class="left"><img class="img" v-lazy="obj.coverurl" alt=""></div>
                <div class="right">
                    <div class="title text-ellipse">{{obj.subject}}</div>
                    <div class="sort">{{obj.kmctype | kmcname}}</div>
                    <!--<div class="price tc-red">￥{{obj.finalpaymoney}}</div>-->
                </div>
            </div>
            <div class="bottom">
                <!--<span :class="cls(obj.status)">{{obj.statustext}}</span>-->
                <div class="price tc-red">￥{{obj.finalpaymoney}}</div>
                <div>
                    <van-button class="cancel" type="default" v-if="obj.status==9 || obj.status==1"
                                @click="cancelOrder(obj)">取消
                    </van-button>
                    <van-button class="pay" type="default" v-if="obj.status==9" @click="getPayUrl(obj)">去付款</van-button>
                    <van-button class="pay" type="default" v-if="obj.status==100" @click="gotoActivity(obj)">重新购买
                    </van-button>

                    <van-button class="finish" type="default" v-if="obj.status==30 && obj.kmctype===7"
                                @click="goStudy(obj)">开始学习
                    </van-button>
                    <van-button class="finish" type="default" v-if="obj.status==30 && obj.kmctype===8"
                                @click="goExamination(obj)">进入考试
                    </van-button>
                    <van-button class="finish" type="default" v-if="obj.status==30 && obj.kmctype===2"
                                @click="goSeeReport(obj)">查看报告
                    </van-button>
                    <van-button class="finish" type="default" v-if="obj.kmctype===13"
                                @click="goSeeActivity(obj)">查看票卷
                    </van-button>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {orderCode, _setClass, _filter} from 'api/enumCode'
  import {cancelMyOrderInfo} from 'api/systemApi'
  import {getPayResultInfo} from 'api/api'
  import {cancelEventOrderByEnroll, getAaOrderPayUrl} from 'api/activeTools'
  import {mapActions} from 'vuex'

  export default {
    name: 'mDataList',
    props: ['orderList'],
    data() {
      return {}
    },
    methods: {
      gotoActivity(obj) {
        this.setRefresh(true)
        this.$router.push({name: 'ActivityDetail', query: {eventid: obj.courseid}})
      },
      goSeeActivity(obj) {
        this.setRefresh(true)
        this.$router.push({name: 'ticketDetails', query: {orderno: obj.orderno, eventid: obj.courseid}})
      },
      gotoView(obj) {
        this.setRefresh(true)
        this.$router.push({name: 'MOrderView', query: {orderno: obj.orderno, kmctype: obj.kmctype}})
      },
      cancelOrder(obj) {
        this.$dialog.confirm({
          title: '提示',
          message: '确定取消订单？'
        }).then(() => {
          if (obj.kmctype == 13) {
            this._cancelEventOrderByEnroll(obj)
          } else {
            this._cancelMyOrderInfo(obj)
          }
        }).catch(() => {
        })
      },
      _cancelMyOrderInfo(obj) {
        this.setLoading(true)
        cancelMyOrderInfo({
          data: {orderno: obj.orderno},
          success: () => {
            this.setLoading(false)
            obj.status = 100
            this.$toast.success('操作成功')
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      _cancelEventOrderByEnroll(obj) {
        this.setLoading(true)
        cancelEventOrderByEnroll({
          data: {orderno: obj.orderno},
          success: () => {
            this.setLoading(false)
            obj.status = 100
            this.$toast.success('操作成功')
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      getPayUrl(obj) {
        if (obj.kmctype == 13) {
          this._getAaOrderPayUrl(obj)
        } else {
          this._getPayUrl(obj)
        }
      },
      _getPayUrl(obj) {
        this.setLoading(true)
        let resulturl = window.location.protocol + '//' + window.location.host + this.$router.resolve({name: 'MPayResult'}).href
        getPayResultInfo({
          data: {
            orderno: obj.orderno,
            resulturl: resulturl
          },
          success: data => {
            this.setLoading(false)
            window.location.href = data.data.url
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      _getAaOrderPayUrl(obj) {
        this.setLoading(true)
        let resulturl = window.location.protocol + '//' + window.location.host + this.$router.resolve({name: 'MPayResult'}).href
        getAaOrderPayUrl({
          data: {
            orderno: obj.orderno,
            resulturl: resulturl
          },
          success: data => {
            this.setLoading(false)
            window.location.href = data.data
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      //开始学习
      goStudy(obj) {
        this.$router.push({name: 'MCourseView', query: {'cid': obj.courseid, active: 0}})
      },
      // 查看报告
      goSeeReport(obj) {
        this.$router.push({name: 'MReportDetails', query: {reportid: obj.courseid}})
        this.setRefresh(true)
      },
      // 进入考试
      goExamination(obj) {
        this.$router.push({name: 'PaperDetails', query: {'qid': obj.courseid, active: 1}});
        this.setRefresh(true)
      },
      ...mapActions(['setRefresh', 'setLoading'])
    },
    filters: {
      kmcname(value) {
        return _filter(value, orderCode.kmcname)
      }
    },
    watch: {},
    computed: {
      cls() {
        return function (value) {
          return _setClass(value, orderCode.status)
        }
      }
    },
    components: {}
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/variable";

    .mDataList {
        color: $c-gray;
        font-size: 0.24rem;
        .box {
            padding: 0.24rem 0.32rem 0.2rem 0.32rem;
            overflow: hidden;
            box-sizing: border-box;
            background: $c-white;
            .top {
                margin-bottom: 0.32rem;
                display: flex;
                justify-content: space-between;
            }
            .middle {
                padding-bottom: 0.3rem;
                display: flex;
                justify-content: flex-start;
                font-size: 0.26rem;
                border-bottom: 0.01rem solid $line;
                .left {
                    min-width: 1.8rem;
                    max-width: 1.8rem;
                    width: 1.8rem;
                    height: 1rem;
                    margin-right: 0.2rem;
                    .img {
                        width: 100%;
                        height: 100%;
                        border-radius: 0.04rem;
                    }
                }
                .right {
                    width: 4.84rem;
                    display: flex;
                    justify-content: space-between;
                    flex-direction: column;
                    .title {
                        width: 100%;
                    }
                    .sort {
                        margin-bottom: 0.15rem;
                        font-size: 0.24rem;
                        color: #666;
                    }
                }
            }
            .bottom {
                margin-top: 0.12rem;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .van-button {
                    box-sizing: border-box;
                    width: 1.3rem;
                    height: 0.46rem;
                    line-height: 0.46rem;
                    border-radius: 0.23rem;
                    font-size: 0.24rem;
                    padding: 0;
                    text-align: center;
                    &:before{
                        border-width: 0;
                    }
                }
                .van-button + .van-button {
                    margin-left: 0.24rem;
                }
                .cancel {
                    color: #C0C4CC;
                    border-color: #C0C4CC;
                }
                .pay {
                    color: $c-white;
                    background: $c-red;
                    border-width: 0;
                }
                .finish {
                    background: #409EFF !important;
                    color: $c-white;
                }
            }
        }
        .box + .box {
            margin-top: 0.2rem;
        }
    }
</style>